import { FC } from "react";
import { IonButton } from "@ionic/react";
import { useTranslation } from "react-i18next";

interface VideoRequestFileProps {
    onRequestFile: () => void;
}

/**
 * Overlay prompt shown over an empty video area, inviting the user to select a
 * video file. Ported from the legacy VideoRequestFileDirective.
 */
const VideoRequestFile: FC<VideoRequestFileProps> = ({ onRequestFile }) => {
    const { t } = useTranslation();
    return (
        <div className="video-request-file">
            <IonButton onClick={onRequestFile}>
                {t("performance.VideoRequestFile.select")}
            </IonButton>
        </div>
    );
};

export default VideoRequestFile;
